import { Button, Paper, Stack, Typography } from '@mui/material';
import { FunctionComponent, ReactNode } from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import React from 'react';

const MeinBereichPaper: FunctionComponent<MeinBereichPaperProps> = ({ titleIcon, title, children }) => {
	return (
		<>
			<Paper sx={{ padding: '1rem', marginTop: '1rem', minHeight: '20rem', borderRadius: '32px' }}>
				<Stack direction={'row'} spacing={1} alignItems={'center'}>
					{titleIcon}
					<Typography variant="h3">{title}</Typography>
				</Stack>

				<Stack spacing={2} sx={{ marginTop: '2rem' }} alignItems={'center'}>
					{children}
				</Stack>
			</Paper>
		</>
	);
};

const MeinBereichButton: FunctionComponent<MeinBereichButtonProps> = ({ buttonName, onClick, disabled = false }) => {
	return (
		<>
			<Button variant="meinBereich" endIcon={<KeyboardArrowRightIcon />} onClick={onClick} disabled={disabled}>
				{buttonName}
			</Button>
		</>
	);
};

interface MeinBereichPaperProps {
	titleIcon?: ReactNode;
	title: string;
	children: ReactNode;
}
interface MeinBereichButtonProps {
	buttonName: string;
	onClick?: () => void;
	disabled?: boolean;
}
export { MeinBereichPaper, MeinBereichButton };
